import { StoreAction, XmAction } from 'store/actions';
import { NowDeviceCollection, NowLineAutoPayCollection } from './models';
import { NowBillingSummaryResponse } from './models/billing-summary';
import { NowLineDetails } from './models/line-details';
import { NowLineBadgesCollection } from './models/badges';
import { NowPauseCancelPort } from './models/pause-cancel-port';
import { NowPortOutSendPin } from './models/send-pin';
import { NowPortOutChangeNotify } from './models/change-notify';
import { NowPortOutAuthCheck } from './models/port-out-auth';

export function nowDeviceCollectionReducer(state: NowDeviceCollection[] = [], action: XmAction<NowDeviceCollection>): NowDeviceCollection[] {
    let newState: NowDeviceCollection[];
    switch (action.type) {
        case StoreAction.GET_NOW_DEVICES:
            newState = state.filter((item: NowDeviceCollection) => item.lineId !== action.payload.lineId);

            return [ ...newState, action.payload ];
        case StoreAction.CLEAR_NOW_DEVICES:
            if (!action.filters) {
                return undefined;
            }

            newState = state.filter((item: NowDeviceCollection) => item.lineId !== action.filters.lineId);

            return [ ...newState, action.payload ];
        default:
            return state;
    }
}

export function nowLineDetailsReducer(state: NowLineDetails, action: XmAction<NowLineDetails>): NowLineDetails {
    switch (action.type) {
        case StoreAction.GET_NOW_LINE_DETAILS:
            return action.payload;
        default:
            return state;
    }
}

export function nowBillingSummaryReducer(state: NowBillingSummaryResponse, action: XmAction<NowBillingSummaryResponse>): NowBillingSummaryResponse {
    switch (action.type) {
        case StoreAction.GET_NOW_BILLING_SUMMARY:
            return action.payload;
        default:
            return state;
    }
}

export function nowLineBadgesReducer(state: NowLineBadgesCollection, action: XmAction<NowLineBadgesCollection>): NowLineBadgesCollection {
    switch (action.type) {
        case StoreAction.GET_NOW_LINE_BADGES:
            return action.payload;
        default:
            return state;
    }
}

export function nowLineAutoPayReducer(state: NowLineAutoPayCollection, action: XmAction<NowLineAutoPayCollection>): NowLineAutoPayCollection {
    switch (action.type) {
        case StoreAction.GET_NOW_LINE_AUTO_PAY:
            return action.payload;
        default:
            return state;
    }
}

export function nowPauseCancelPortReducer(state: NowPauseCancelPort, action: XmAction<NowPauseCancelPort>): NowPauseCancelPort {
    switch (action.type) {
        case StoreAction.GET_NOW_PAUSE_CANCEL_PORT:
            return action.payload;
        default:
            return state;
    }
}

export function nowPortOutSendPinReducer(state: NowPortOutSendPin, action: XmAction<NowPortOutSendPin>): NowPortOutSendPin {
    switch (action.type) {
        case StoreAction.POST_NOW_PORT_OUT_SEND_PIN:
            return action.payload;
        default:
            return state;
    }
}

export function nowPortOutChangeNotifyReducer(state: NowPortOutChangeNotify, action: XmAction<NowPortOutChangeNotify>): NowPortOutChangeNotify {
    switch (action.type) {
        case StoreAction.GET_NOW_PORT_OUT_CHANGE_NOTIFY:
            return action.payload;
        default:
            return state;
    }
}

export function nowPortOutAuthCheckReducer(state: NowPortOutAuthCheck, action: XmAction<NowPortOutAuthCheck>): NowPortOutAuthCheck {
    switch (action.type) {
        case StoreAction.GET_NOW_PORT_OUT_AUTH_CHECK:
            return action.payload;
        default:
            return state;
    }
}
